@if (!featuredCreators?.length) {
  <myp-skeleton-loader type="product-tile" height="250px" [number]="19" class="grid-container pad-10"></myp-skeleton-loader>
}

<ul class="grid-container pad-10">
  @for (creator of featuredCreators; track creator) {
    <li
      tabindex="0"
      [ngStyle]="{ 'min-height': '250px', overflow: 'hidden' }"
      (click)="creatorClicked.next(creator)"
      (keyup.enter)="creatorClicked.next(creator)"
      (keyup.space)="$event.preventDefault(); $event.stopPropagation(); creatorClicked.next(creator)"
      class="exchange-grid-item"
    >
      <div class="position-relative h-full" role="group" aria-label="artist">
        <img src="{{ creator.image_url }}" alt="{{ creator.name }}" />
        <div class="d-flex flex-column justify-content-end h-full position-relative">
          <div class="name">
            <div class="d-flex justify-content-between">
              <h5 class="bold t-20 creator-title">{{ creator.name }}</h5>
              <fa-icon icon="chevron-right"></fa-icon>
            </div>
          </div>
        </div>
      </div>
    </li>
  }
</ul>
